import ProductDataFactory from "./ProductDataFactory";
var GoogleTagManagerUtil = (function () {
    function GoogleTagManagerUtil() {
    }
    GoogleTagManagerUtil.productClick = function (event, product, list, index) {
        var _a;
        if (!((_a = window.ONNIT) === null || _a === void 0 ? void 0 : _a.googleTagManager)) {
            console.error("Google Tag Manager: Cannot send product click because `window.ONNIT.googleTagManager` is undefined.");
            return;
        }
        if (window.ONNIT.googleTagManager.isSdkLoaded()) {
            event.preventDefault();
        }
        var productData = ProductDataFactory.fromProduct(product, list, index + 1);
        window.ONNIT.googleTagManager.productClick([productData], list, event.currentTarget.href);
    };
    GoogleTagManagerUtil.productImpression = function (products, list) {
        var _a, _b;
        (_b = (_a = window.ONNIT) === null || _a === void 0 ? void 0 : _a.googleTagManager) === null || _b === void 0 ? void 0 : _b.productImpression(products.map(function (product, index) { return (ProductDataFactory.fromProduct(product, list, index + 1)); }));
    };
    return GoogleTagManagerUtil;
}());
export default GoogleTagManagerUtil;
//# sourceMappingURL=GoogleTagManagerUtil.js.map